module.exports = function() {
    $(function() {
        $('.navicon').click(function() {
            $(document.body).toggleClass('navactive');
        })
    })
}